module.exports = __webpack_public_path__ + "img/ewm2.ca4e348f.png";